import initGameMiddleware from './initGame.middleware'
import coreMiddleware from './core'
import { routerMiddleware } from '../router/router'
import gameMiddleware from './game'

export default [
    initGameMiddleware,
    ...coreMiddleware,
    routerMiddleware,
    ...gameMiddleware,
]
